import { Center, ConditionalRendering, Loader, Text } from "@marketplace/ui";
import { getRouteApi } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import { Pagination } from "@/components";
import { TransactionsEmptyState } from "@/modules/shared";

import { TransactionHistoryFilter } from "../../components/transaction-history-filter";
import { TransactionHistoryTable } from "../../components/transaction-history-table";
import { useGetTransactionHistoryListQuery } from "../../hooks/queries/use-get-transaction-history-list-query";

const route = getRouteApi("/transaction-history/");

export const TransactionHistoryListPage = () => {
  const { page, q, sort } = route.useSearch();
  const navigate = route.useNavigate();
  const { t } = useTranslation("order", {
    keyPrefix: "transactionHistoryPage"
  });

  const { data: responseData, isLoading } = useGetTransactionHistoryListQuery({
    queryParams: {
      page,
      limit: 10,
      q,
      sort
    }
  });

  const metadata = responseData?.metadata;
  const records = responseData?.data ?? [];

  return (
    <>
      <div className="mb-6">
        <Text type="heading" size="l" className="text-humble-blue-500">
          {t("title")}
        </Text>
        <Text size="l" className="text-fjord-grey-400">
          {t("description")}
        </Text>
      </div>

      <TransactionHistoryFilter />

      <ConditionalRendering condition={!isLoading && !records.length}>
        <div className="relative mt-[42px] flex justify-center">
          <TransactionsEmptyState />
          <Text
            type="heading"
            className="absolute bottom-[65px] text-fjord-grey-500"
          >
            {t("emptyStateLabel.default")}
          </Text>
        </div>
      </ConditionalRendering>

      <ConditionalRendering condition={records && records.length > 0}>
        <div className="space-y-6">
          <TransactionHistoryTable records={records} />
          <Pagination
            currentPageTotal={records.length}
            totalData={metadata?.total}
            total={metadata?.totalPage ?? 0}
            value={metadata?.page}
            onChange={(value) =>
              navigate({
                search: (prev) => ({
                  ...prev,
                  page: value
                })
              })
            }
          />
        </div>
      </ConditionalRendering>

      <ConditionalRendering condition={isLoading}>
        <Center className="my-20">
          <Loader />
        </Center>
      </ConditionalRendering>
    </>
  );
};
